const mainState = {
  authState: false,
  userInfo: null,
}

export default mainState